/* eslint-disable no-param-reassign */
/*
 *
 * MemberDetail reducer
 *
 */
import { createSlice } from '@reduxjs/toolkit';
import {
  getMemberDetailAct,
  getMemberDetailErrorAct,
  getMemberDetailSuccessAct,
  removeMealAct,
  removeMealErrorAct,
  removeMealSuccessAct,
  resetMemberDetail,
  transferMealAct,
  transferMealErrorAct,
  transferMealSuccessAct,
  updateMedCertAct,
  updateMedCertErrorAct,
  updateMedCertSuccessAct,
  updateParentalConsentAct,
  updateParentalConsentErrorAct,
  updateParentalConsentSuccessAct,
  updateTagStateAct,
  updateTagStateErrorAct,
  updateTagStateSuccessAct,
  updateTshirtSizeAct,
  updateTshirtSizeErrorAct,
  updateTshirtSizeSuccessAct,
} from './actions';

export const initialState = {
  loadingState: 0,
  error: '',
  member: null,
  memberCertState: 0,
  memberParentConsentState: 0,
  memberTshirtState: 0,
  mealUpdateState: 0,
  mealAction: '',
};

const onMealUpdateStart = action => state => {
  state.mealAction = action;
  state.mealUpdateState = 1;
  state.error = '';
};

const onMealUpdateError = (state, { payload }) => {
  const { error } = payload;
  state.mealUpdateState = 3;
  state.error = error;
  state.mealAction = '';
  // update state of the meal by id to 0
};

const removeMealSuccess = state => {
  state.member.meal = null;
  state.mealUpdateState = 2;
  state.error = '';
};

/* eslint-disable default-case, no-param-reassign */
const memberDetailSlice = createSlice({
  name: 'MemberDetail',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getMemberDetailAct, state => {
        state.loadingState = 1;
        state.error = '';
      })
      .addCase(getMemberDetailErrorAct, (state, { payload }) => {
        state.loadingState = 3;
        state.error = payload;
      })
      .addCase(getMemberDetailSuccessAct, (state, { payload }) => {
        state.loadingState = 2;
        state.error = '';
        state.member = payload;
      })
      .addCase(updateMedCertAct, (state, { payload }) => {
        const { data } = payload;
        state.member.medicalCertificateState = data.value;
        state.memberCertState = 1;
        state.error = '';
      })
      .addCase(updateMedCertErrorAct, (state, { payload }) => {
        const { error, oldValue } = payload;
        state.memberCertState = 3;
        state.member.medicalCertificateState = oldValue;
        state.error = error;
      })
      .addCase(updateMedCertSuccessAct, (state, { payload }) => {
        state.member = { ...state.member, ...payload };
        state.memberCertState = 2;
        state.error = '';
      })
      .addCase(updateParentalConsentAct, (state, { payload }) => {
        const { data } = payload;
        state.memberParentConsentState = 1;
        state.member.parentalConsentState = data.value;
        state.error = '';
      })
      .addCase(updateParentalConsentErrorAct, (state, { payload }) => {
        const { error, oldValue } = payload;
        state.memberParentConsentState = 3;
        state.member.parentalConsentState = oldValue;
        state.error = error;
      })
      .addCase(updateParentalConsentSuccessAct, (state, { payload }) => {
        state.member = { ...state.member, ...payload };
        state.memberParentConsentState = 2;
        state.error = '';
      })
      .addCase(updateTshirtSizeAct, (state, { payload }) => {
        const { data } = payload;
        state.memberTshirtState = 1;
        state.member.tshirtSize = data.value;
        state.error = '';
      })
      .addCase(updateTshirtSizeErrorAct, (state, { payload }) => {
        const { error, oldValue } = payload;
        state.memberTshirtState = 3;
        state.member.tshirtSize = oldValue;
        state.error = error;
      })
      .addCase(updateTshirtSizeSuccessAct, (state, { payload }) => {
        state.member = { ...state.member, ...payload };
        state.memberTshirtState = 2;
        state.error = '';
      })
      .addCase(updateTagStateAct, (state, { payload }) => {
        const { data } = payload;
        const { tagId } = data;
        const { member } = state;
        if (member.tags) {
          const tag = member.tags.find(tg => tg.id === tagId);
          if (tag) {
            tag.loadingState = 1;
          }
        }
        state.error = '';
        state.tagState = 1;
      })
      .addCase(updateTagStateErrorAct, (state, { payload }) => {
        const { tagId, error, isAssigned } = payload;
        const { member } = state;
        if (member.tags) {
          const tag = member.tags.find(tg => tg.id === tagId);
          if (tag) {
            tag.loadingState = 3;
            tag.status.active = isAssigned;
          }
        }
        state.tagState = 3;
        state.error = error;
      })
      .addCase(updateTagStateSuccessAct, (state, { payload }) => {
        const { memberTagId: tagId, active } = payload;
        const { member } = state;
        if (member.tags) {
          const tag = member.tags.find(tg => tg.id === tagId);
          if (tag) {
            tag.loadingState = 0;
            tag.status.active = active;
          }
        }
        state.tagState = 2;
        state.error = '';
      })
      .addCase(transferMealAct, onMealUpdateStart('transfer'))
      .addCase(transferMealErrorAct, onMealUpdateError)
      .addCase(transferMealSuccessAct, removeMealSuccess)
      .addCase(removeMealAct, onMealUpdateStart('delete'))
      .addCase(removeMealErrorAct, onMealUpdateError)
      .addCase(removeMealSuccessAct, removeMealSuccess)
      .addCase(resetMemberDetail, () => initialState);
  },
});

export default memberDetailSlice.reducer;
